module.exports = __webpack_public_path__ + "img/shield.5695a389.svg";